var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('aron-table',{key:_vm.route,attrs:{"uploadEndpoint":"/uploadFile","endPoint":_vm.route,"filterEndpoint":_vm.filterEndpoint,"formType":_vm.formType}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }